var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validation-wrapper"},[_c('h2',[_vm._v("\n    Validating access.\n  ")]),_c('h2',[_vm._v("\n    Please wait...\n  ")]),_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }